import styled from 'styled-components'

export const FieldGridStyled = styled.div`
  display: grid;
  grid-template-columns: repeat(
    2,
    minmax(0, ${(props) => props.theme.typography.pxToRem(400)})
  );
  gap: ${(props) => props.theme.space.large};
`
